export default __webpack_public_path__ + "static/media/careWhiteHollow.8351dc65.svg";